export function lifecycleHookImport(): string {
  return `\nimport { getAuditRequestMetadata } from '@admin/actions/audit/request-metadata'
import { runAfterHooks, runBeforeHooks } from '@admin/lib/lifecycle-hooks'`
}

interface LifecycleContextOptions {
  schemaType?: 'entity' | 'form'
  sourceType?: 'admin_ui' | 'server_action' | 'system_job'
  userExpression?: string
}

export function lifecycleContext(
  entityType: string,
  extras: string,
  options: LifecycleContextOptions = {}
): string {
  const userExpression = options.userExpression ?? 'actor'
  const sourceType = options.sourceType ?? 'admin_ui'
  const schemaType = options.schemaType
    ? `\n      schemaType: '${options.schemaType}' as const,`
    : ''

  return `{
      user: ${userExpression},
      entityType: '${entityType}',${schemaType}
      timestamp: now,
      sourceType: '${sourceType}' as const,
      ipAddress: auditRequestMetadata.ipAddress,
      userAgent: auditRequestMetadata.userAgent${extras}
    }`
}

export function beforeHook(event: string, context: string): string {
  return `await runBeforeHooks('${event}', ${context})`
}

export function afterHook(event: string, context: string): string {
  return `runAfterHooks('${event}', ${context})`
}
